/** Registra o Service Worker para permitir a instalação do Harpia no coletor. */
export default defineNuxtPlugin(() => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      void navigator.serviceWorker.register("/sw.js");
    });
  }
});
